import DesignPopup from '@/common/components/modal/DesignPopup.vue';
import ReportModal from '@customer/views/shops/modal/ReportModal.vue';
import ReportUserModal from '@customer/views/shops/modal/ReportUserModal.vue';
import ReportPopup from '@/common/components/modal/ReportPopup';
import {
  mapActions as reviewMapActions,
  mapGetters as reviewMapGetters,
} from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';
import { authGetters, authMapGetters } from '@common/store/modules';
import { mapGetters as shopMapGetters } from '@common/store/modules/shop';
import { mapActions, mapState, mapGetters } from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import Review from '@customer/views/shops/components/Review.vue';
import MultipleImageModal from '@/common/components/modal/MultipleImage.vue';

import {
  sleep,
  connectedSocket,
  closeSocket,
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
  jsonEscape,
  toBR,
} from '@common/lib/common/utils';

export default {
  components: {
    Review,
    DesignPopup,
    ReportModal,
    ReportUserModal,
    ReportPopup,
    MultipleImageModal,
  },
  data() {
    return {
      dpData: {
        type: 'confirm',
        msg: '',
      },
      designPopup: false,
      reportModal: false,
      reportUserModal: false,
      reportPopup: false,
      selectedReview: {
        id: 0,
        userId: 0,
      },
      isShowImageModal: false,
      clickedImageUrls: [],
      clickedImageIndex: 0,
    };
  },
  props: {
    reviews: Array,
    option: Object,
    from: String,
    isSearchPage: Boolean,
  },
  computed: {
    ...authMapGetters({
      curUser: authGetters.CURRENT_USER,
    }),
    ...shopMapGetters({
      shop: shopTypes.SHOP,
    }),
    isCustomer() {
      return process.env.VUE_APP_APP_NAME === 'customer';
    },
  },
  methods: {
    ...reviewMapActions([
      reviewTypes.REPORT_REVIEW,
      reviewTypes.REPORT_REVIEW_USER,
      reviewTypes.DELETE_REVIEW,
      reviewTypes.FETCH_REVIEWS,
    ]),
    ...mapActions([shopTypes.FETCH_SHOP]),
    openReportModal(review) {
      // this.selectedReview = review;
      this.closeReportPopup();
      this.reportModal = true;
    },
    closeReportModal() {
      this.reportModal = false;
      this.selectedReview = {
        id: 0,
        userId: 0,
      };
    },
    openReportPopup(review) {
      this.selectedReview = review;
      this.reportPopup = true;
    },
    closeReportPopup() {
      this.reportPopup = false;
    },
    openReportUserModal(review) {
      // this.selectedReview = review;
      this.closeReportPopup();
      this.reportUserModal = true;
    },
    closeReportUserModal() {
      this.reportUserModal = false;
      this.selectedReview = {
        id: 0,
        userId: 0,
      };
    },
    async reviewReport(reason) {
      const params = {
        reason: reason,
        reviewId: this.selectedReview.id,
        storeId: this.shop.id,
        userId: this.selectedReview.userId,
      };
      await this[reviewTypes.REPORT_REVIEW](params);
      await this[shopTypes.FETCH_SHOP]({ id: this.shop.id });
      const review_params = {
        storeId: this.shop.id,
        visible: true,
        del: false,
      };

      // 리뷰
      await this[reviewTypes.FETCH_REVIEWS](review_params);
      this.closeReportModal();
      this.dpData = {
        type: 'alert',
        msg: '신고하였습니다.',
      };
      this.designPopup = true;
    },
    async reviewReportUser() {
      console.log('this.selectedReview');
      console.log(this.selectedReview);
      const params = {
        // reviewId: this.selectedReview.id,
        // storeId: this.shop.id,
        userId: this.selectedReview.userId,
      };
      await this[reviewTypes.REPORT_REVIEW_USER](params);
      var shopInfo = await this[shopTypes.FETCH_SHOP]({ id: this.shop.id });

      this.$emit('shopInfoRefresh', shopInfo);
      const review_params = {
        storeId: this.shop.id,
        visible: true,
        del: false,
      };

      // 리뷰
      await this[reviewTypes.FETCH_REVIEWS](review_params);
      this.closeReportUserModal();
      this.dpData = {
        type: 'alert',
        msg: '신고하였습니다.',
      };
      this.designPopup = true;
    },
    handlerDelete(reviewId) {
      this.dpData = {
        type: 'confirm',
        msg: '삭제하시겠습니까?',
      };
      this.selectedReview.id = reviewId;
      this.designPopup = true;
    },
    deleteReview(isDelete) {
      this.designPopup = false;
      if (isDelete) {
        const params = {
          id: this.selectedReview.id,
        };
        let data = this[reviewTypes.DELETE_REVIEW](params);
        this.dpData = {
          type: 'alert',
          msg: '삭제되었습니다.',
        };
        this.designPopup = true;
      } else {
        this.designPopup = false;
        // 삭제가 완료되면
        if (this.dpData.type === 'alert') {
          this.selectedReview.id = 0;
          this.$emit('deleteReview');
        }
      }
    },
    handelImage(urls, index) {
      this.isShowImageModal = true;
      this.clickedImageUrls = urls;
      this.clickedImageIndex = index;
      this.$refs.multipleImageModal.imageClickIndex = index;
      nativeDisableBackKey();
    },
    closeImageModal() {
      this.isShowImageModal = false;
      this.clickedImageUrls = [];
      this.clickedImageIndex = 0;
      nativeEnableBackKey();
    },
  },
};
